import {AbstractActionService} from '../../../../../../core/service/v2/service/action/abstractAction.service';
import {SaleInvoiceSendByEmailPayload} from './payload/email/SaleInvoiceSendByEmail.payload';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable()
export class SaleInvoiceSendByEmailActionService extends AbstractActionService<SaleInvoiceSendByEmailPayload, any> {
    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient) {
        super('SaleInvoice', 'send', customizeHttpUrlGenerator, httpClient);
    }
}
